export default "__VITE_ASSET__D_S5VY4T__"